import React from 'react';
import { useTranslation } from 'react-i18next';

// assets
import { General } from 'icons/untitledui';

// styles
import * as Buttons from 'theme/components/Buttons.style';
import * as Styled from 'onboarding/styles/SlideNotifications.style';

interface SlideNotificationsProps {
  isBusy: boolean;
  onAllow: () => void;
  onSkip: () => void;
}

function SlideNotifications({
  isBusy,
  onAllow,
  onSkip,
}: SlideNotificationsProps): JSX.Element {
  const { t } = useTranslation('pageOnboarding');

  return (
    <Styled.Slide>
      <Styled.Hero>
        <Styled.BellIcon aria-hidden="true">
          <General.Bell04 />
        </Styled.BellIcon>
        <Styled.TextSection>
          <Styled.Header>{t('SlideNotifications.title')}</Styled.Header>
          <Styled.Description>
            {t('SlideNotifications.description')}
          </Styled.Description>
        </Styled.TextSection>
      </Styled.Hero>

      <Styled.Actions>
        <Buttons.Primary
          type="button"
          onClick={onAllow}
          disabled={isBusy}
          aria-busy={isBusy}
          stretch
        >
          {t('SlideNotifications.allow')}
        </Buttons.Primary>
        <Buttons.SecondaryLight
          type="button"
          onClick={onSkip}
          disabled={isBusy}
          stretch
        >
          {t('SlideNotifications.notNow')}
        </Buttons.SecondaryLight>
      </Styled.Actions>
    </Styled.Slide>
  );
}

export default SlideNotifications;
